<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Mensagens enviadas
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Histórico de mensagens enviadas pelo WhatsApp. Filtre por instância, destinatário e período.
        </p>
      </div>
    </div>

    <form class="mt-3">
      <div class="form-row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="filtroInstancia">Instância</label>
            <select id="filtroInstancia" class="form-control" [(ngModel)]="filters.id_instancia" name="id_instancia">
              <option [ngValue]="null">Todas</option>
              <option *ngFor="let inst of instancias" [ngValue]="inst.id">{{ inst.nome }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="filtroDestinatario">Destinatário (número)</label>
            <input type="text" id="filtroDestinatario" class="form-control" [(ngModel)]="filters.destinatario" name="destinatario" placeholder="Ex: 5511999999999" />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="filtroDataInicio">Data início</label>
            <input type="text" id="filtroDataInicio" class="form-control" mask="00/00/0000" [(ngModel)]="filters.data_inicio" name="data_inicio" placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="filtroDataFim">Data fim</label>
            <input type="text" id="filtroDataFim" class="form-control" mask="00/00/0000" [(ngModel)]="filters.data_fim" name="data_fim" placeholder="dd/mm/aaaa" />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="filtroStatus">Status</label>
            <select id="filtroStatus" class="form-control" [(ngModel)]="filters.status" name="status">
              <option [ngValue]="null">Todos</option>
              <option value="pendente">Pendente</option>
              <option value="enviada">Enviada</option>
              <option value="entregue">Entregue</option>
              <option value="falha">Falha</option>
            </select>
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <div class="form-group mb-0 w-100">
            <button type="button" class="btn btn-outline-secondary mr-1" (click)="limparFiltros()">Limpar</button>
            <button type="button" class="btn btn-primary" (click)="aplicarFiltros()"><i class="fa fa-search mr-1"></i>Filtrar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="mensagens.length > 0">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th>Data/Hora</th>
        <th>Instância</th>
        <th>Destinatário</th>
        <th>Tipo</th>
        <th>Status</th>
        <th>Texto / Legenda</th>
        <th>Arquivo</th>
        <th>Erro</th>
        <th>Ação</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let msg of mensagens">
        <td class="pl-3 pr-3 align-middle">{{ formatarData(msg.data_hora) }}</td>
        <td class="align-middle">{{ msg.nome_instancia || '–' }}</td>
        <td class="align-middle">{{ msg.destinatario }}</td>
        <td class="align-middle">{{ tipoLabel(msg.tipo_mensagem) }}</td>
        <td class="align-middle"><span class="badge" [ngClass]="statusClass(msg.status)">{{ statusLabel(msg.status) }}</span></td>
        <td class="align-middle text-break text-left" style="max-width: 200px;">
          <span *ngIf="msg.texto">{{ msg.texto }}</span>
          <span *ngIf="!msg.texto" class="text-muted">–</span>
        </td>
        <td class="align-middle">
          <a *ngIf="msg.link_arquivo" [href]="msg.link_arquivo" target="_blank" rel="noopener">Abrir</a>
          <span *ngIf="!msg.link_arquivo" class="text-muted">–</span>
        </td>
        <td class="align-middle text-break text-left" style="max-width: 180px;">
          <span *ngIf="msg.status === 'falha' && msg.erro_envio" class="text-danger" [title]="msg.erro_envio">{{ msg.erro_envio }}</span>
          <span *ngIf="msg.status !== 'falha' || !msg.erro_envio" class="text-muted">–</span>
        </td>
        <td class="align-middle">
          <button *ngIf="msg.status === 'pendente'" type="button" class="btn btn-sm btn-outline-danger" (click)="excluirMensagem(msg)" title="Remover da fila">Excluir</button>
          <span *ngIf="msg.status !== 'pendente'" class="text-muted">–</span>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="form-row" *ngIf="total > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
        Exibindo {{ startItem }} a {{ endItem }} de {{ total }} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
          class="ml-auto pagination-square"
          style="margin-top: 10px; margin-right: 10px"
          *ngIf="total > 0"
          [(page)]="page"
          [pageSize]="limit"
          [maxSize]="3"
          [rotate]="true"
          [boundaryLinks]="true"
          size="sm"
          [collectionSize]="total"
          (pageChange)="onPageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="mensagens.length === 0 && !filters.id_instancia && !filters.destinatario && !filters.data_inicio && !filters.data_fim && !filters.status">
  <div class="card-body">
    <div class="text-center py-4">
      <h5 class="mt-0">Nenhuma mensagem encontrada</h5>
      <p class="text-muted">Ainda não há mensagens enviadas ou ajuste os filtros.</p>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="mensagens.length === 0 && (filters.id_instancia || filters.destinatario || filters.data_inicio || filters.data_fim || filters.status)">
  <div class="card-body">
    <div class="text-center py-4">
      <h5 class="mt-0">Nenhum resultado</h5>
      <p class="text-muted">Nenhuma mensagem corresponde aos filtros aplicados.</p>
      <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">Limpar filtros</button>
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
